const oficialia = {
  TraePendientes: 'TemisCivil/GetFoliosPendientes',
  TraeZonas: 'TemisCivil/GetZonas',
  Guardado: 'TemisCivil/GuardaEditaDocumento',
  Eliminar:'TemisCivil/EliminarFolio',
  PermiteEditar:'TemisCivil/EditarFolio',
  InfoDoc:'TemisCivil/GetInfoDoc',
  InfoPadrePromo:'TemisCivil/GetInfoPadrePromocion',
  Impresionleyendas: 'TemisCivil/ImprimirLeyenda',
  EnviarDocumentos: 'TemisCivil/EnviarDocumentos',
  ReporteEnviados: 'TemisCivil/GetReporteEnvio',
  ImpresionRecibos: 'TemisCivil/ImprimirRecibo',
  ImprimeTabla: 'TemisCivil/ImprimirContenidoTabla',
  AsignacionDirecta: 'TemisCivil/AsignacionDirecta',
  ModulosUsuario: 'TemisCivil/GetModulosUsuario',
};

export default oficialia;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/temiscivil/sistema/oficialia/oficialia.js
// module id = null
// module chunks = 